<template>
  <div class="products">
    <div class="may-like">
      Seu cliente também pode gostar
    </div>

    <v-layout
      class="recommended"
    >
      <v-card
        v-for="(product, index) in recommendedProducts"
        :key="index"
        :index="index"
        class="recommended__product"
        @click="goToProduct(product)"
      >
        <img
          class="recommended__product__image"
          :src="getProductImage(product.skus)"
          @error="showFallbackImage"
        >

        <div class="recommended__product__code">
          Código {{ product.skus[0].sku_id_erp }}
        </div>

        <div class="recommended__product__name">
          {{ product.descricaoCurta }}
        </div>

        <div class="recommended__product__price">
          {{ product.skus[0].sku_prices[0].price | currency }}
        </div>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    recommendedProducts: {
      type: Array,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters(['getCustomer']),
  },

  methods: {
    getProductImage(sku) {
      return sku[0].sku_images.length > 0 ? sku[0].sku_images[0].image : '';
    },

    showFallbackImage(event) {
      const e = event;
      e.target.src = 'https://konselior.s3.amazonaws.com/media/semImagem.jpg';
    },

    goToProduct(product) {
      const query = {};

      if (this.getCustomer.salesAssistant) query.skuId = product.skus[0].id;

      this.$router.push({
        name: 'detalhamento de produtos',
        params: { id: product.id },
        query,
      });

      this.$store.dispatch('setSelectedProductColor', product.cor);
    },
  },
};
</script>

<style lang="scss" scoped>
.products {
  margin-top: 30px;
}

.may-like {
  display: flex;
  margin-left: 0;
  color: #000;
  font-family: Nunito Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.recommended {
  display: flex;
  flex-direction: row;
  text-align: left;
  padding: 16px 16px 16px 0px;
  align-items: flex-start;
  gap: 10px;
  overflow: auto;

  &__product {
    width: 168px;
    height: 248px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    background: #FFF;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.10);

    &__image {
      width: 136px;
      height: 139.2px;
    }

    &__code {
      color: rgba(20, 12, 34, 0.50);
      font-family: Nunito Sans;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 10px;
    }

    &__name {
      color: var(--closer-black, #140C22);
      font-family: Nunito Sans;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
    }

    &__price {
      color: var(--verde-primrio, #0C4439);
      font-family: Nunito Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
    }
  }
}

</style>
